//
//    Havin' side scrolling problems? I feel bad for you, son.
//    This code's got 99 problems but side-scrolling ain't one.
//
// It'll create a side-scrolling area within your div, and provide a helpful
// hint for your less side-scroll-savvy users!
//
// Use this directive INSTEAD OF overflow-x:scroll.
//
// NOTE: This is some awful UI. Try to not use side-scrolling next time!
//
// NOTE 2: This isn't a component. It's a true directive, providing hacks and
//         doing weird things with JS and HTML.

import angular from 'angular';

module.exports = angular.module('market.side-scroll-hint', [
])
.directive('sideScrollHint', ($window) => {
  return {
    restrict: 'A',
    bindToController: true,
    controllerAs: 'directiveCtrl',
    controller: class {
      constructor($element) {
        var container =
          $element[0].querySelector('.side-scroll-hint-container');
        this.scrollContainerEl = angular.element(container);
        this.scrollTowardRight = true;
      }

      getElementWidth(el) {
        return parseInt($window.getComputedStyle(el).width);
      }

      showMore() {
        var scrollLeftInitial = this.scrollContainerEl.scrollLeft();
        this.scrollContainerEl.scrollTo(scrollLeftInitial + 400, 0, 500)
        .then(() => {
          var scrollLeft = this.scrollContainerEl.scrollLeft();

          var containerWidth = this.getElementWidth(this.scrollContainerEl[0]);

          // We can't calculate this in the construtor because ng-transclude
          // hasn't finished setup yet, and things aren't rendered yet either
          var contentWidth = this.scrollContainerEl[0].scrollWidth;

          // Not sure why the off-by-one error happens
          if (containerWidth + scrollLeft + 1 >= contentWidth) {
            this.scrollTowardRight = false;
          }
        });
      }

      backToStart() {
        this.scrollContainerEl.scrollTo(0, 0, 500);
        this.scrollTowardRight = true;
      }
    },
    template: require('./side-scroll-hint.jade')(),
    transclude: true
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/directives/side-scroll-hint.js
 **/